import {
  Box,
  Container,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Login from "../components/Authentication/Login";
import Signup from "../components/Authentication/Signup";
import './home.css';

function Homepage() {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userInfo"));

    if (user) navigate("/workspace");
  }, [navigate]);

  return (
    <Container maxW="5xl" centerContent className="container">
      <Box className="content-box">
        <Box className="left-box translucent-box">
          <Box d="flex" justifyContent="center" p={3}>
            <Text fontSize="4xl" fontFamily="Work sans">
             COMCONNECT
            </Text>
          </Box>
          <Box p={4}>
            <Tabs isFitted variant="soft-rounded">
              <TabList mb="1em">
                <Tab>Login</Tab>
                <Tab>Sign Up</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <Login />
                </TabPanel>
                <TabPanel>
                  <Signup />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </Box>
        <Box className="right-box">
          <img src="https://herobot.app/wp-content/uploads/2022/11/11-Reasons-Why-A-Chat-Application-Is-Great-For-Business_1.jpg" alt="Decorative" className="right-image" />
        </Box>
      </Box>
    </Container>
  );
}

export default Homepage;
